import React from 'react';
import styled, { css } from 'styled-components';
import { useI18n } from '../i18n/index';
import { fadeInUp, withMotion } from '../styles/animations';
import { theme } from '../styles/theme';

const DisclaimerPanel = () => {
  const { t } = useI18n();

  return (
    <Panel role="note" aria-label={t('info.safetyTitle')}>
      <Icon aria-hidden="true">⚠</Icon>
      <Content>
        <Title>{t('info.safetyTitle')}</Title>
        <Text>{t('app.disclaimer')}</Text>
        <SafetyNote>{t('info.safetyText')}</SafetyNote>
      </Content>
    </Panel>
  );
};

const Panel = styled.aside`
  display: flex;
  gap: ${theme.spacing.md};
  align-items: flex-start;
  background: rgba(245,158,11,0.05);
  border: 1px solid rgba(245,158,11,0.2);
  border-radius: ${theme.radius.xl};
  padding: ${theme.spacing.lg} ${theme.spacing.xl};

  ${withMotion(css`
    animation: ${fadeInUp} 0.5s ease both;
    animation-delay: 0.5s;
  `)}

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    flex-direction: column;
    gap: ${theme.spacing.sm};
  }
`;

const Icon = styled.span`
  font-size: 20px;
  flex-shrink: 0;
  line-height: 1.4;
  color: ${theme.colors.warningAmber};
  margin-top: 1px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`;

const Title = styled.h3`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${theme.colors.warningAmber};
`;

const Text = styled.p`
  font-size: 12px;
  color: ${theme.colors.textSecondary};
  line-height: 1.65;
`;

const SafetyNote = styled.p`
  font-size: 11px;
  color: ${theme.colors.textMuted};
  line-height: 1.6;
  margin-top: 2px;
`;

export default DisclaimerPanel;
